/**
 * Aevex Country Selector — client-side behaviour
 * ------------------------------------------------
 * • Persists choice in localStorage + cookie
 * • Dropdown open/close with click & keyboard
 * • Reloads page with ?country=XX on change
 */
(function () {
  'use strict';

  /* ---- constants ------------------------------------------- */
  var STORAGE_KEY = 'aevex_country';
  var COOKIE_NAME = 'country_code';
  var COOKIE_DAYS = 365;
  var COUNTRIES = {
    US: { name: 'United States', currency: 'USD', symbol: '$' },
    CA: { name: 'Canada',        currency: 'CAD', symbol: 'CA$' },
    IN: { name: 'India',         currency: 'INR', symbol: '₹' }
  };

  /* ---- helpers --------------------------------------------- */
  function getCookie(name) {
    var v = document.cookie.match('(^|;)\\s*' + name + '=([^;]*)');
    return v ? decodeURIComponent(v[2]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getStoredCountry() {
    // 1. URL param
    var p = new URLSearchParams(window.location.search).get('country');
    if (p && COUNTRIES[p.toUpperCase()]) return p.toUpperCase();
    // 2. localStorage
    var ls = null;
    try { ls = localStorage.getItem(STORAGE_KEY); } catch (_) {}
    if (ls && COUNTRIES[ls]) return ls;
    // 3. Cookie
    var ck = getCookie(COOKIE_NAME);
    if (ck && COUNTRIES[ck.toUpperCase()]) return ck.toUpperCase();
    return 'CA';
  }

  /* ---- SVG flags ------------------------------------------- */
  var FLAGS = {
    US: '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><rect width="640" height="480" fill="#B22234"/><rect y="37" width="640" height="37" fill="#fff"/><rect y="111" width="640" height="37" fill="#fff"/><rect y="185" width="640" height="37" fill="#fff"/><rect y="259" width="640" height="37" fill="#fff"/><rect y="333" width="640" height="37" fill="#fff"/><rect y="407" width="640" height="37" fill="#fff"/><rect width="260" height="260" fill="#3C3B6E"/><g fill="#fff"><circle cx="26" cy="20" r="6"/><circle cx="78" cy="20" r="6"/><circle cx="130" cy="20" r="6"/><circle cx="182" cy="20" r="6"/><circle cx="234" cy="20" r="6"/><circle cx="52" cy="40" r="6"/><circle cx="104" cy="40" r="6"/><circle cx="156" cy="40" r="6"/><circle cx="208" cy="40" r="6"/><circle cx="26" cy="60" r="6"/><circle cx="78" cy="60" r="6"/><circle cx="130" cy="60" r="6"/><circle cx="182" cy="60" r="6"/><circle cx="234" cy="60" r="6"/><circle cx="52" cy="80" r="6"/><circle cx="104" cy="80" r="6"/><circle cx="156" cy="80" r="6"/><circle cx="208" cy="80" r="6"/><circle cx="26" cy="100" r="6"/><circle cx="78" cy="100" r="6"/><circle cx="130" cy="100" r="6"/><circle cx="182" cy="100" r="6"/><circle cx="234" cy="100" r="6"/><circle cx="52" cy="120" r="6"/><circle cx="104" cy="120" r="6"/><circle cx="156" cy="120" r="6"/><circle cx="208" cy="120" r="6"/><circle cx="26" cy="140" r="6"/><circle cx="78" cy="140" r="6"/><circle cx="130" cy="140" r="6"/><circle cx="182" cy="140" r="6"/><circle cx="234" cy="140" r="6"/><circle cx="52" cy="160" r="6"/><circle cx="104" cy="160" r="6"/><circle cx="156" cy="160" r="6"/><circle cx="208" cy="160" r="6"/><circle cx="26" cy="180" r="6"/><circle cx="78" cy="180" r="6"/><circle cx="130" cy="180" r="6"/><circle cx="182" cy="180" r="6"/><circle cx="234" cy="180" r="6"/><circle cx="52" cy="200" r="6"/><circle cx="104" cy="200" r="6"/><circle cx="156" cy="200" r="6"/><circle cx="208" cy="200" r="6"/><circle cx="26" cy="220" r="6"/><circle cx="78" cy="220" r="6"/><circle cx="130" cy="220" r="6"/><circle cx="182" cy="220" r="6"/><circle cx="234" cy="220" r="6"/><circle cx="52" cy="240" r="6"/><circle cx="104" cy="240" r="6"/><circle cx="156" cy="240" r="6"/><circle cx="208" cy="240" r="6"/></g></svg>',
    CA: '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><rect width="192" height="480" fill="#FF0000"/><rect x="192" width="256" height="480" fill="#fff"/><rect x="448" width="192" height="480" fill="#FF0000"/><path d="M320 120l-18 38-20-8-12 18 30 6-4 22 24-16 24 16-4-22 30-6-12-18-20 8z" fill="#FF0000"/></svg>',
    IN: '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><rect width="640" height="160" fill="#FF9933"/><rect y="160" width="640" height="160" fill="#fff"/><rect y="320" width="640" height="160" fill="#138808"/><circle cx="320" cy="240" r="40" fill="none" stroke="#000080" stroke-width="4"/><circle cx="320" cy="240" r="8" fill="#000080"/></svg>'
  };

  /* ---- build DOM ------------------------------------------- */
  function buildBar() {
    var current = getStoredCountry();
    var info = COUNTRIES[current];

    var bar = document.createElement('div');
    bar.className = 'aevex-country-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Country and region selector');

    bar.innerHTML =
      '<div class="container aevex-country-bar__inner">' +
        '<div class="aevex-country-bar__globe">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="8"/><path d="M4 12h16M12 4c2.2 2.2 3.3 4.9 3.3 8S14.2 17.8 12 20M12 4c-2.2 2.2-3.3 4.9-3.3 8S9.8 17.8 12 20"/></svg>' +
        '</div>' +
        '<span class="aevex-country-bar__message">Shopping from <strong>' + info.name + '</strong> · ' + info.currency + '</span>' +

        '<div style="position:relative">' +
          '<button class="aevex-country-bar__trigger" aria-expanded="false" aria-haspopup="listbox" aria-label="Change country: ' + info.name + '">' +
            '<span class="aevex-country-bar__flag">' + FLAGS[current] + '</span>' +
            '<span>' + current + '</span>' +
            '<svg class="aevex-country-bar__chevron" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="m3 4.5 3 3 3-3"/></svg>' +
          '</button>' +
          '<div class="aevex-country-bar__dropdown" role="listbox" aria-label="Select country"></div>' +
        '</div>' +

        '<button class="aevex-country-bar__close" aria-label="Dismiss country bar">' +
          '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="m2 2 8 8M10 2l-8 8"/></svg>' +
        '</button>' +
      '</div>';

    return bar;
  }

  function buildOptions(dropdown, current) {
    var keys = ['US', 'CA', 'IN'];
    keys.forEach(function (code) {
      var c = COUNTRIES[code];
      var btn = document.createElement('button');
      btn.className = 'aevex-country-bar__option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', code === current ? 'true' : 'false');
      btn.setAttribute('data-country', code);
      btn.setAttribute('tabindex', '0');
      btn.innerHTML =
        '<span class="aevex-country-bar__option-flag">' + FLAGS[code] + '</span>' +
        '<span class="aevex-country-bar__option-info">' +
          '<span class="aevex-country-bar__option-name">' + c.name + '</span>' +
          '<span class="aevex-country-bar__option-currency">' + c.currency + ' (' + c.symbol + ')</span>' +
        '</span>' +
        '<svg class="aevex-country-bar__option-check" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5l3.5 3.5L13 4"/></svg>';
      dropdown.appendChild(btn);
    });
  }

  /* ---- keyboard nav ---------------------------------------- */
  function keyboardNav(dropdown, trigger, options, e) {
    var idx = Array.prototype.indexOf.call(options, document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      var next = idx < options.length - 1 ? idx + 1 : 0;
      options[next].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      var prev = idx > 0 ? idx - 1 : options.length - 1;
      options[prev].focus();
    } else if (e.key === 'Escape') {
      close(dropdown, trigger);
      trigger.focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      options[0].focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      options[options.length - 1].focus();
    }
  }

  /* ---- open / close ----------------------------------------- */
  function open(dropdown, trigger) {
    dropdown.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }
  function close(dropdown, trigger) {
    dropdown.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  /* ---- select country --------------------------------------- */
  function selectCountry(code) {
    code = code.toUpperCase();
    if (!COUNTRIES[code]) return;
    try { localStorage.setItem(STORAGE_KEY, code); } catch (_) {}
    setCookie(COOKIE_NAME, code, COOKIE_DAYS);

    // Add ?country=XX and reload (strip existing country param first)
    var url = new URL(window.location.href);
    url.searchParams.set('country', code);
    window.location.href = url.toString();
  }

  /* ---- hide bar (dismiss) ----------------------------------- */
  function hideBar(bar) {
    bar.classList.remove('is-visible');
    try { localStorage.setItem('aevex_country_bar_hidden', '1'); } catch (_) {}
    setCookie('aevex_country_bar_hidden', '1', 1);
  }

  /* ---- init ------------------------------------------------- */
  function init() {
    // Check if user dismissed
    var dismissed = false;
    try { dismissed = localStorage.getItem('aevex_country_bar_hidden') === '1'; } catch (_) {}
    if (dismissed) return;

    // Also check URL param to skip on reload after change
    var urlHasCountry = new URLSearchParams(window.location.search).has('country');

    var bar = buildBar();
    var trigger = bar.querySelector('.aevex-country-bar__trigger');
    var dropdown = bar.querySelector('.aevex-country-bar__dropdown');
    var closeBtn = bar.querySelector('.aevex-country-bar__close');
    var current = getStoredCountry();

    buildOptions(dropdown, current);

    // Insert at top of body
    document.body.insertBefore(bar, document.body.firstChild);

    // Show bar (slight delay for animation)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.classList.add('is-visible');
      });
    });

    // --- Event: trigger click
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      if (isOpen) { close(dropdown, trigger); }
      else { open(dropdown, trigger); }
    });

    // --- Event: option clicks
    var options = dropdown.querySelectorAll('.aevex-country-bar__option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectCountry(opt.getAttribute('data-country'));
      });
    });

    // --- Event: keyboard
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open(dropdown, trigger);
        var firstOpt = dropdown.querySelector('.aevex-country-bar__option');
        if (firstOpt) firstOpt.focus();
      }
    });
    dropdown.addEventListener('keydown', function (e) {
      keyboardNav(dropdown, trigger, options, e);
    });

    // --- Event: click outside closes
    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) {
        close(dropdown, trigger);
      }
    });

    // --- Event: close button
    closeBtn.addEventListener('click', function () {
      hideBar(bar);
    });

    // --- Focus trap for dropdown
    dropdown.addEventListener('blur', function (e) {
      // Small delay to allow focus to move within dropdown
      setTimeout(function () {
        if (!dropdown.contains(document.activeElement) && document.activeElement !== trigger) {
          close(dropdown, trigger);
        }
      }, 50);
    });
  }

  /* ---- boot ------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
